"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _BlurFilter = _interopRequireDefault(require("./BlurFilter"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _convertMapToObject = _interopRequireDefault(require("../../../utils/object/convertMapToObject"));

var _deepCopy = _interopRequireDefault(require("../../../utils/object/deepCopy"));

var _isNil = _interopRequireDefault(require("../../../utils/object/isNil"));

var _isEmpty = _interopRequireDefault(require("../../../utils/array/isEmpty"));

var _isNotEmpty = _interopRequireDefault(require("../../../utils/array/isNotEmpty"));

var _isNumber = _interopRequireDefault(require("../../../utils/numbers/isNumber"));

var _creative = require("../../../constants/creative");

var _isNotEmptyString = _interopRequireDefault(require("../../../utils/object/isNotEmptyString"));

var _isEmptyString = _interopRequireDefault(require("../../../utils/object/isEmptyString"));

var Filters = /*#__PURE__*/function () {
  // order of filters
  function Filters(filtersByName, filters) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Filters);
    (0, _defineProperty2["default"])(this, "_filters", []);
    (0, _defineProperty2["default"])(this, "_filtersByName", new Map());

    if ((0, _isNotEmpty["default"])(filters)) {
      this._filters = (0, _deepCopy["default"])(filters);
    } // map valid filters


    if (!(0, _isNil["default"])(filtersByName)) {
      var filterNames = Object.keys(filtersByName);
      filterNames.forEach(function (filterName) {
        if (!_creative.VALID_FILTERS.has(filterName)) return;
        var filter = filtersByName[filterName];

        switch (filterName) {
          case _creative.FILTERS_TO_FILTER_NAMES[_creative.FILTERS.BLUR]:
            if (!(0, _isNil["default"])(filter) && (0, _isNumber["default"])(filter.radius)) {
              _this.addBlurFilter(filtersByName[filterName].radius);
            }

            break;

          default:
            break;
        }
      });
    }
  }

  (0, _createClass2["default"])(Filters, [{
    key: "addBlurFilter",

    /* Convenient methods */
    value: function addBlurFilter(value) {
      var blurFilter = new _BlurFilter["default"](value);
      var filterName = blurFilter.getName();
      this.filtersByName.set(filterName, blurFilter); // update filters order
      // if filter already exist, remove the previous order

      var index = this.filters.indexOf(filterName);

      if (index !== -1) {
        this.filters.splice(index, 1);
      }

      this.filters.push(filterName);
    }
  }, {
    key: "addFilter",
    value: function addFilter(filter) {
      if (!_Filter["default"].isFilter(filter)) {
        throw new Error('filter must be of type Filter');
      }

      var filterName = filter.getName();

      if (!_creative.VALID_FILTERS.has(filterName)) {
        throw new Error('filter must be of a valid Filter');
      }

      this.filtersByName.set(filterName, filter); // update filters order
      // if filter already exist, remove the previous order

      var index = this.filters.indexOf(filterName);

      if (index !== -1) {
        this.filters.splice(index, 1);
      }

      this.filters.push(filterName);
    }
  }, {
    key: "addFilterByName",
    value: function addFilterByName(filterName, value) {
      if (!_creative.VALID_FILTERS.has(filterName)) {
        throw new Error('filter name is not valid');
      }

      if ((0, _isNil["default"])(value)) {
        throw new Error('filter value is nil');
      }

      switch (filterName) {
        case _creative.FILTERS_TO_FILTER_NAMES[_creative.FILTERS.BLUR]:
          this.addBlurFilter(value);
          break;

        default:
          break;
      }
    }
  }, {
    key: "copy",
    value: function copy() {
      var copied = new Filters();
      this.filtersByName.forEach(function (filter) {
        copied.addFilter(filter);
      });
      return copied;
    }
  }, {
    key: "equals",
    value: function equals(inFilters) {
      if (!Filters.isFilters(inFilters)) return false;
      return this.toString() === inFilters.toString();
    }
  }, {
    key: "getValueByFilterName",
    value: function getValueByFilterName(filterName) {
      var filter = this.filtersByName.get(filterName);
      if (!_Filter["default"].isFilter(filter)) return 0;
      return filter.getValue();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return (0, _isEmpty["default"])(this._filters);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        filtersByName: (0, _convertMapToObject["default"])(this.filtersByName, function (value) {
          return value.toJSON();
        }),
        filters: this.filters
      };
    }
    /**
     * @function toString
     * @return {String} Converts the filters to a string representation.
     */

  }, {
    key: "toString",
    value: function toString() {
      if (this.filtersByName.size === 0) {
        return '[none]';
      }

      var stringifiedFilters = [];
      this.filtersByName.forEach(function (filter) {
        stringifiedFilters.push(filter.toString());
      });
      return stringifiedFilters.join(' ');
    }
    /**
     * @function toString
     * @return {String} Converts the filters to a canvas string representation.
     */

  }, {
    key: "toCanvasString",
    value: function toCanvasString() {
      if (this.filtersByName.size === 0) {
        return _Filter["default"].NONE;
      }

      var stringifiedFilters = [];
      this.filtersByName.forEach(function (filter) {
        if (!_Filter["default"].isFilter(filter)) return;
        var filterCanvasString = filter.toCanvasString();

        if ((0, _isNotEmptyString["default"])(filterCanvasString)) {
          stringifiedFilters.push(filterCanvasString);
        }
      });
      var canvasString = stringifiedFilters.join(' ').trim();
      return (0, _isEmptyString["default"])(canvasString) ? _Filter["default"].NONE : canvasString;
    }
    /**
     * Checks if object is an instance of Filters
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "filters",
    get: function get() {
      return this._filters;
    },
    set: function set(value) {
      this._filters = value;
    }
  }, {
    key: "filtersByName",
    get: function get() {
      return this._filtersByName;
    },
    set: function set(value) {
      this._filtersByName = value;
    }
  }], [{
    key: "isFilters",
    value: function isFilters(inputObject) {
      return inputObject instanceof Filters;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if ((0, _isNil["default"])(json)) {
        return null;
      }

      return new Filters(json.filtersByName, json.filters);
    }
    /**
     * Combine parent filters to child filters
     * The expected combined filters should contain:
     * 1. ALL of the child filters first (eg. first in the list of order)
     * with parent filters combined if parent filters contain the same filter
     *    eg. if parent has a blur filter of 10, and child has a blur filter of 5, the end result should be 15
     *    eg. if parent does not have a blur filter, and child has a blur filter of 5, the end result should be 5
     * 2. The rest of parents filters that do not exist on the combined filters from (1)
     *    eg. if parent has a blur filter of 5, and child does not have a blur fliter, the end result should be 5
     *
     * @param parentFilters
     * @param childFilters
     * @returns {Filters}
     */

  }, {
    key: "combine",
    value: function combine(parentFilters, childFilters) {
      if (!Filters.isFilters(parentFilters) || !Filters.isFilters(childFilters)) {
        throw new Error('both parent and child Filters must be of type Filters');
      }

      var combinedFilters = childFilters.copy();
      parentFilters.filtersByName.forEach(function (parentFilter) {
        var parentFilterName = parentFilter.getName();
        var foundFilter = combinedFilters.filtersByName.get(parentFilterName); // combine with parent filter

        if (_Filter["default"].isFilter(foundFilter)) {
          foundFilter.combine(parentFilter); // if not found, just add it the the list of filters
        } else {
          combinedFilters.addFilter(parentFilter.copy());
        }
      });
      return combinedFilters;
    }
  }]);
  return Filters;
}();

exports["default"] = Filters;